import {
  GetTimeEntriesGroupedByUserQuery,
  GetTimeEntriesGroupedByUserQueryVariables,
  useGetTimeEntriesGroupedByUserQuery,
} from "generated/graphql";
import { useCallback, useMemo } from "react";
export type GetTimeEntriesGroupedByUserVariables = GetTimeEntriesGroupedByUserQueryVariables;

export const useGetTimeEntriesGroupedByUser = ({
  variables,
  skip = false,
}: {
  variables: GetTimeEntriesGroupedByUserVariables;
  skip?: boolean;
}) => {
  const { data: graphqlData, error, loading } = useGetTimeEntriesGroupedByUserQuery({
    variables,
    skip,
  });

  const getData = useCallback(({ data }: { data: GetTimeEntriesGroupedByUserQuery }) => {
    return data?.getTimeEntriesGroupedByUser?.data || null;
  }, []);

  const getPaginatorInfo = useCallback(({ data }: { data: GetTimeEntriesGroupedByUserQuery }) => {
    return data?.getTimeEntriesGroupedByUser?.paginatorInfo || null;
  }, []);

  const data = useMemo(() => {
    return getData({ data: graphqlData });
  }, [graphqlData]);

  const paginatorInfo = useMemo(() => {
    return getPaginatorInfo({ data: graphqlData });
  }, [graphqlData]);

  return { loading, data, error, getData, getPaginatorInfo, paginatorInfo } as const;
};
